import { useSyncExternalStore } from "react";

const KEY = "torri_cart";
const listeners = new Set();

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
}
function write(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
  listeners.forEach((l) => l());
}

export const cartStore = {
  subscribe(cb) { listeners.add(cb); return () => listeners.delete(cb); },
  getSnapshot() { return localStorage.getItem(KEY) || "[]"; },
  items() { return read(); },
  add(item) {
    const items = read();
    const i = items.findIndex((x) => x.slug === item.slug);
    if (i >= 0) items[i].qty += item.qty || 1;
    else items.push({ ...item, qty: item.qty || 1 });
    write(items);
  },
  setQty(slug, qty) {
    write(read().map((x) => (x.slug === slug ? { ...x, qty: Math.max(1, qty) } : x)));
  },
  remove(slug) { write(read().filter((x) => x.slug !== slug)); },
  clear() { write([]); },
};

export function useCart() {
  const snap = useSyncExternalStore(cartStore.subscribe, cartStore.getSnapshot, cartStore.getSnapshot);
  return JSON.parse(snap);
}
